import { DatasourceRequestParams } from 'common/interfaces'

export const DIGITAL_TEE_DATASOURCE_KIND = 'digital_tee'

/**
 * Attach the live Flow Builder session id for digital_tee datasources only.
 * Other kinds are left unchanged so existing static flows that send sessionId
 * themselves keep working. digital_tee copies this sibling onto context.sessionId.
 */
export function withDigitalTeeSessionId(
  params: DatasourceRequestParams,
  sessionId: string | null | undefined,
  datasourceKind?: string | null
): DatasourceRequestParams {
  if (!sessionId || datasourceKind !== DIGITAL_TEE_DATASOURCE_KIND) {
    return params
  }

  return {
    ...params,
    sessionId,
  }
}
